export const searchableIndexesValues = {
  KEYWORD: 'keyword',
  IDENTIFIER: 'identifiers.value',
  PERSONAL_NAME: 'personalNameTitle',
  CORPORATE_CONFERENCE_NAME: 'corporateNameTitle',
  GEOGRAPHIC_NAME: 'geographicName',
  NAME_TITLE: 'nameTitle',
  UNIFORM_TITLE: 'uniformTitle',
  SUBJECT: 'subject',
  CHILDREN_SUBJECT_HEADING: 'childrenSubjectHeading',
  GENRE: 'genre',
  ADVANCED_SEARCH: 'advancedSearch',
};
